var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"error"}},[_vm._m(0),_c('br'),_c('br'),_c('br'),_c('router-link',{attrs:{"tag":"button","to":"/"}},[_vm._v("العودة إلى الصفحة الرئيسية")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v("404")]),_c('p',[_vm._v(" هذه الصفحة غير موجودة ")])])
}]

export { render, staticRenderFns }